import React, { FC } from 'react';
import Typography, { TypographyProps } from '@material-ui/core/Typography';
import ApplicationMessageBox from './ApplicationMessageBox';
import T from 'i18n-react';

const Li: FC<TypographyProps<'li'>> = (props) => (
  <Typography color="textPrimary" component="li" {...props} />
);

const NoApplicableTerm = () => {
  return (
    <ApplicationMessageBox>
      <Typography color="error" gutterBottom>
        {T.translate('applicant.new.noTerm')}
      </Typography>
      <ul>
        <Li>{T.translate('applicant.new.dueToNoApplicable')}</Li>
        <Li>{T.translate('applicant.new.dueToOngoingTerm')}</Li>
        <Li>{T.translate('applicant.new.dueToOverlapping')}</Li>
        <Li>{T.translate('applicant.new.suspended')}</Li>
      </ul>
    </ApplicationMessageBox>
  );
};

export default NoApplicableTerm;
